import { createSelector } from '@reduxjs/toolkit'
export const SLICE_NAME = 'sso'
const select = (state: any) => state[SLICE_NAME]
export const getSSOValidateData = createSelector(
  select,
  sso => sso.ssoValidation
)

export const getCustomerName = createSelector(select, sso => sso.customerName)
